export default "__VITE_ASSET__47e1f507__"